import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useTokenGenerationStore = defineStore("tokenGeneration", () => {
  // State
  const _apiKey = ref<string>("");
  const _apiKeyExpiry = ref<number | null>(null);
  const _isTokenLoading = ref<boolean>(false);

  // Getters
  const apiKey = computed(() => _apiKey.value);
  const apiKeyExpiry = computed(() => _apiKeyExpiry.value);
  const isTokenLoading = computed(() => _isTokenLoading.value);

  // Actions
  const setApiKey = (key: string) => {
    _apiKey.value = key;
  };

  const setApiKeyExpiry = (expiry: number | null) => {
    _apiKeyExpiry.value = expiry;
  };

  const setSsTokenLoading = (loading: boolean) => {
    _isTokenLoading.value = loading;
  };

  return {
    apiKey,
    apiKeyExpiry,
    isTokenLoading,
    setApiKey,
    setApiKeyExpiry,
    setSsTokenLoading,
  };
});
